export type PaymentSchedule = {
  title: string
  note: string
  percentage: number
  amount: number
  sequence: number,
}

export type PaymentScheduleRow = PaymentSchedule & {
  canDelete: boolean,
  canUpdatePercentage: boolean 
}

export const defaultPaymentScheduleRow = (): PaymentScheduleRow => ({
  title: '',
  note: '',
  percentage: 0,
  amount: 0,
  sequence: 0,
  canDelete: false,
  canUpdatePercentage: false,
})

export type PaymentScheduleOptions = {
  useProgressBasedOnly?: boolean
  quotedAndTimeAndMaterials: {
    selectedOption: PaymentScheduleQuotedAndTimeAndMaterialsOption
    intervalBased: {
      totalPayments: number
      recurring: RecurringPayment
    },
    progressBased: PaymentScheduleRow[]
  }
  perVisit: {
    recurring: RecurringPayment
  }
}

export type PaymentScheduleQuotedAndTimeAndMaterialsOption = 'paid-upfront' | 'progress-based' | 'interval-based'

export type RecurringPayment = {
  estimatedStartDate: string | null
  invoiceEvery: number
  invoiceEveryUnit: InvoiceEveryUnit
  weeklyRepeatOn: DayOfWeek
  monthlyOption: RecurringPaymentMonthlyOption
  monthlyRepeatOnDay: number
  monthlyRepeatEveryNthWeek: NthWeek
  monthlyRepeatOn: DayOfWeek
  hideScheduleOnProposal: boolean
}

export type DayOfWeek = 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday'
export type InvoiceEveryUnit = 'weeks' | 'months'
export type RecurringPaymentMonthlyOption = 'day' | 'nth-week'
export type NthWeek = 'first' | 'second' | 'third' | 'fourth'


export type ProposalSettings = {
  sendProposalPdfByDefault: boolean;
  estimateProposalSalesTaxByDefault: boolean;
  enableSalesNotificationsOnCustomerViewsByDefault: boolean;
  redirectToDownPaymentCheckoutOnApprovalByDefault: boolean;
  showCompanyAddressByDefault: boolean;
  projectsTerms: string;
  serviceTicketsTerms: string;
  maintenanceTerms: string;
  defaultPaymentScheduleOptions: PaymentScheduleOptions;
}

export type TenantLink = {
  id: number
  url: string
  displayText: string
}

export type GeneralSettings = {
  sendProposalPdfByDefault: boolean
  estimateProposalSalesTaxByDefault: boolean
  enableSalesNotificationsOnCustomerViewsByDefault: boolean
  redirectToDownPaymentCheckoutOnApprovalByDefault: boolean
}

export type ProposalTermsAndConditions = {
  projectsTerms: string
  serviceTicketsTerms: string
  maintenanceTerms: string
}

export type DefaultFollowUpAutomationSchedule = {
  tenantId: number
  followUpAutomation: AutomationSchedule
  followUpAutomationEnabled: boolean
}

export type AutomationSchedule = {
  steps: AutomationScheduleStep[],
  enabled: boolean
}

export type AutomationScheduleStep = {
  id: string
  type: StepType
  afterDays: number
  atTime: string
  emailTemplateGuid: string
}

type StepType = 'follow-up'